<dialog-base [width]="25" [height]="20" [isError]="isErrorInfo">
    <div header-slot>Jak uzyskać hasło?</div>
    <div content-slot>
      <div>
        <span class="text-black">Po zarejestrowaniu gwarancji na urządzenie objęte kampanią, </span>
        <span class="text-primary-color">na e-mail zapisany w ProClub wysłane jest jednorazowe hasło </span>
        <span class="text-black">do aktywacji konta pana-store.</span>
    </div>
    </div>
    <div footer-slot class="dialog-buttons-container">
      <button type="button" class="btn btn-primary btn-primary-custom" (click)="confirmMessage()">
      <!-- <button type="button" class="btn btn-primary btn-primary-green23" (click)="confirmMessage()"> -->
        OK
      </button>
    </div>
  </dialog-base>